import Alpine from 'alpinejs';

Alpine.data('blogTitles', (initialData) => ({
    articles: Array.isArray(initialData?.articles) ? initialData.articles : [],
    tags: Array.isArray(initialData?.tags) ? initialData.tags : [],
    selectedTag: typeof initialData?.defaultTag === 'string' ? initialData.defaultTag : '',
    currentPage: 1,
    perPageDesktop: 6,
    perPageMobile: 3,
    isMobile: false,
    isImageBgLayout: true,

    init() {
        const styleAttr = this.$el.getAttribute('data-layout-style');
        this.isImageBgLayout = (styleAttr || 'image') === 'image';

        this.updateBreakpoint();
        this._onResize = () => this.updateBreakpoint();
        window.addEventListener('resize', this._onResize, { passive: true });
    },

    destroy() {
        if (this._onResize) {
            window.removeEventListener('resize', this._onResize);
        }
    },

    updateBreakpoint() {
        const wasMobile = this.isMobile;
        this.isMobile = window.matchMedia('(max-width: 1279px)').matches;
        if (wasMobile !== this.isMobile) {
            const newTotal = Math.max(1, Math.ceil(this.filteredArticles.length / this.perPage));
            if (this.currentPage > newTotal) this.currentPage = newTotal;
        }
    },

    get perPage() {
        return this.isMobile ? this.perPageMobile : this.perPageDesktop;
    },

    get filteredArticles() {
        if (!this.selectedTag) return this.articles;
        return this.articles.filter(a => (a.tag || '') === this.selectedTag);
    },

    get totalPages() {
        return Math.max(1, Math.ceil(this.filteredArticles.length / this.perPage));
    },

    get pageNumbers() {
        const pages = [];
        for (let i = 1; i <= this.totalPages; i++) pages.push(i);
        return pages;
    },

    get paginatedDesktop() {
        const start = (this.currentPage - 1) * this.perPageDesktop;
        return this.filteredArticles.slice(start, start + this.perPageDesktop);
    },

    get paginatedMobile() {
        const start = (this.currentPage - 1) * this.perPageMobile;
        return this.filteredArticles.slice(start, start + this.perPageMobile);
    },

    setTag(tag) {
        this.selectedTag = tag || '';
        this.currentPage = 1;
    },

    goToPage(page) {
        if (page < 1 || page > this.totalPages) return;
        this.currentPage = page;
    },

    isTallSlot(index) {
        return index === 2 || index === 3;
    },

    desktopSlotClass(index) {
        switch (index) {
            case 0: return 'col-start-1 row-start-1 h-[340px]';
            case 1: return 'col-start-2 row-start-1 h-[340px]';
            case 2: return 'col-start-3 row-start-1 row-span-2 h-[720px]';
            case 3: return 'col-start-1 row-start-2 row-span-2 h-[720px]';
            case 4: return 'col-start-2 row-start-3 h-[340px]';
            case 5: return 'col-start-3 row-start-3 h-[340px]';
            default: return 'h-[340px]';
        }
    },

    cardImage(article, index) {
        if (this.isMobile) {
            return article.square_image || article.rectangle_image || '';
        }
        if (this.isTallSlot(index)) {
            return article.rectangle_image || article.square_image || '';
        }
        return article.square_image || article.rectangle_image || '';
    },

    cardAlt(article, index) {
        if (this.isMobile) {
            return article.square_alt || article.rectangle_alt || article.title || '';
        }
        if (this.isTallSlot(index)) {
            return article.rectangle_alt || article.square_alt || article.title || '';
        }
        return article.square_alt || article.rectangle_alt || article.title || '';
    },

    // Intrinsic [width, height] of whichever file cardImage() picks, so the <img> can carry
    // width/height attributes (CLS) even though the src is chosen at runtime.
    cardDims(article, index) {
        const square = Array.isArray(article.square_dims) ? article.square_dims : [];
        const rectangle = Array.isArray(article.rectangle_dims) ? article.rectangle_dims : [];
        if (this.isMobile) {
            return article.square_image ? square : rectangle;
        }
        if (this.isTallSlot(index)) {
            return article.rectangle_image ? rectangle : square;
        }
        return article.square_image ? square : rectangle;
    },
}));
